import { selectors } from 'app-webtech-core';
import Cookie from 'js-cookie';
import debug from 'debug';
import { getDomain } from './getDomain';

const logger = debug('web:application:utils:pixels');

function isFeatureFlagEnabled(envVal, name) {
  const parseValue = (val) => {
    switch (typeof val) {
      case 'string':
        return val === 'true' || val === '1';
      case 'number':
        return val === 1;
      default:
        return val;
    }
  };
  let value = parseValue(envVal);
  if (!value && localStorage && localStorage[name]) {
    value = parseValue(localStorage[name]);
  }

  return value;
}

const COOKIE_NAME = 'plutotv_uid';
const MARKETING_REGION = {
  US: 'us',
  LATAM: 'latam',
  UK: 'uk',
  GSA: 'gsa',
  EU: 'eu',
  BR: 'br',
};
const availableMarketingRegions = [
  MARKETING_REGION.US,
  MARKETING_REGION.LATAM,
  MARKETING_REGION.BR,
];
const isMarketingRegionAvailable = (marketingRegion) =>
  availableMarketingRegions.some((region) => region === marketingRegion);
const cookieSyncApi = process.env.COOKIE_SYNC_API;

export const processPixels = async (getState) => {
  if (!isFeatureFlagEnabled(process.env.ENABLE_PIXELS, 'ENABLE_PIXELS')) {
    logger('Pixels feature not enabled');
    return;
  }

  const { setup: { clientID } = {} } = selectors.application.properties(getState());
  const { marketingRegion } = selectors.playbackSession.properties(getState());
  // TODO: Check and create cookie when not EU
  if (isMarketingRegionAvailable(marketingRegion)) {
    const domain = getDomain();
    logger('Creating plutotv_uid cookie for', domain);
    Cookie.set(COOKIE_NAME, clientID, {
      domain,
      expires: 365,
    });

    const response = await fetch(
      `${cookieSyncApi}/v1/pixel?plutotv_uid=${clientID}&region=${marketingRegion}`,
      {
        credentials: 'include',
      },
    );
    const { pixels } = await response.json();
    logger('Sending pixels');
    await Promise.all(pixels.map((url) => fetch(url, { credentials: 'include', mode: 'no-cors' })));
  }
};
